import { shouldShowToolbar } from "@circle-react-shared/uikit/TipTap/Extensions/TextModifiers/utilities";
import { useBubbleMenuOptions } from "@circle-react-shared/uikit/TipTap/utilities/useBubbleMenuOptions";
import { useAddTipTapLinkModal } from "@circle-react-shared/uikit/TipTapBlockEditor/AddTipTapLinkModal";
import type { IconName } from "@circleco/compass/components/Icon";
import { IconToggleButton } from "@circleco/compass/components/IconToggleButton";
import { BubbleMenu } from "@tiptap/react/menus";

import { t } from "@/i18n-js/instance";

import type { TextModifiersMenuProps } from "./types";

export const TextModifiersComponent = ({
  editor,
  allowBubbleMenuOverflow = true,
}: TextModifiersMenuProps) => {
  const useAddTipTapLink = useAddTipTapLinkModal();
  const bubbleMenuOptions = useBubbleMenuOptions(
    "top",
    allowBubbleMenuOverflow,
    editor,
  );

  const options = [
    {
      name: "bold",
      iconType: "bold",
      label: t("tiptap.bubble_menu.bold"),
      onClick: () => editor.chain().focus().toggleBold().run(),
    },
    {
      name: "italic",
      iconType: "italic",
      label: t("tiptap.bubble_menu.italic"),
      onClick: () => editor.chain().focus().toggleItalic().run(),
    },
    {
      name: "strike",
      iconType: "strike-through",
      label: t("tiptap.bubble_menu.strike"),
      onClick: () => editor.chain().focus().toggleStrike().run(),
    },
    {
      name: "underline",
      iconType: "underline",
      label: t("tiptap.bubble_menu.underline"),
      onClick: () => editor.chain().focus().toggleUnderline().run(),
    },
    {
      name: "blockquote",
      iconType: "close-quote",
      label: t("tiptap.bubble_menu.blockquote"),
      onClick: () => editor.chain().focus().toggleBlockquote().run(),
    },
    {
      name: "link",
      iconType: "chain-link",
      label: t("tiptap.bubble_menu.link"),
      onClick: () => useAddTipTapLink.show({ editor: editor }),
    },
    {
      name: "orderedList",
      iconType: "numbered-list",
      label: t("tiptap.bubble_menu.ordered_list"),
      onClick: () => editor.chain().focus().toggleOrderedList().run(),
    },
    {
      name: "bulletList",
      iconType: "bullet-list",
      label: t("tiptap.bubble_menu.bullet_list"),
      onClick: () => editor.chain().focus().toggleBulletList().run(),
    },
  ];

  return (
    <div>
      <BubbleMenu
        editor={editor}
        {...bubbleMenuOptions}
        className="z-[9999]"
        shouldShow={shouldShowToolbar}
      >
        <div className="bg-primary border-primary flex gap-1 rounded-lg border p-0.5 shadow-sm">
          {options.map(option => (
            <IconToggleButton
              key={option.name}
              icon={option.iconType as IconName}
              toggleIcon={option.iconType as IconName}
              onPressedChange={option.onClick}
              size="sm"
              variant="ghost"
              toggleIconColor="primary"
              toggleVariant="secondary"
              pressed={editor.isActive(option.name)}
              aria-label={option.label}
            />
          ))}
        </div>
      </BubbleMenu>
    </div>
  );
};
